import React, { lazy } from "react";

const UserProfile = lazy(() => import("../../../components/user-profile"));

const UserProfileRoute = () => {
    return [
        {
            key: "user_profile",
            path: "/profile",
            component: <UserProfile />,
        }
    ];
};

export default UserProfileRoute;
